export default function showTextareaCharacterCount(){
    //$(function(){
    document.addEventListener('DOMContentLoaded', function(){
        $('div.char-count').each(function(idx, countText){
            let textareaName = $(countText).attr('data-for');
            if (!textareaName){
                console.log('data-for attribute not found');
            }

            let textarea = $('[name="' + textareaName + '"]');
            $(countText).text(textarea.val().length + '文字');
            textarea.on({
                'input': function () {
                    $(countText).text($(this).val().length + '文字');
                }
            });
        });
    });
}

